import React, { useEffect, useState } from "react";
import Select from "@components/forms/Select";
import { Col, Row } from "react-bootstrap";
import ReactApexChart from "react-apexcharts";
import { apiSend, getRoute } from "@services/axios";
const Chart = ({ t, product_id }) => {
  const data = [
    { title: t("today"), value: "today" },
    { title: t("last_week"), value: "week" },
    { title: t("this_month"), value: "month" },
    { title: t("this_year"), value: "year" },
  ];
  const maxValue = 400;
  const [filter, setFilter] = useState("year");

  const [series, setSeries] = useState([
    {
      name: t("sales"),
      group: "sales",
      data: [],
    },
    {
      name: t("earnings"),
      group: "sales",
      data: [],
    },
  ]);

  const [options, setOptions] = useState({
    chart: {
      type: "bar",
      height: maxValue,
      stacked: true,
    },
    stroke: {
      width: 1,
      colors: ["#fff"],
    },
    dataLabels: {
      formatter: (val) => {
        return val + "€";
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    xaxis: {
      categories: [],
    },
    fill: {
      opacity: 1,
    },
    colors: ["#8077ec", "#16A571"],
    yaxis: {
      labels: {
        formatter: (val) => {
          return val + " ";
        },
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  });
  const handleSetFilter = async (value) => {
    setFilter(value);

    const response = await apiSend(
      [
        getRoute("PRODUCT_RETRIEVE"),
        product_id,
        "booking/dashboard",
        value,
      ].join("/"),
      "get"
    );
    if (response?.data?.result?.categories) {
      setSeries([
        {
          name: t("sales"),
          group: "sales",
          data: response?.data?.result?.dataSales,
        },
        {
          name: t("earnings"),
          group: "sales",
          data: response?.data?.result?.dataEarnings,
        },
      ]);

      setOptions({
        chart: {
          type: "bar",
          height: maxValue,
          stacked: true,
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        dataLabels: {
          formatter: (val) => {
            return val + "€";
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        xaxis: {
          categories: response?.data?.result?.categories,
        },
        fill: {
          opacity: 1,
        },
        colors: ["#8077ec", "#16A571"],
        yaxis: {
          labels: {
            formatter: (val) => {
              return val + " ";
            },
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
        },
      });
    }
  };

  useEffect(() => {
    (async () => {
      await handleSetFilter(filter);
    })();
  }, []);

  return (
    <div
      className="bg-white  rounded h-100 d-flex flex-column justify-content-between"
      style={{ overflow: "hidden" }}
    >
      <div className="p-4">
        <Row>
          <Col xl="8">
            <div className="fs-4 fw-bold text-dark">{t("overview")}</div>
            <p className="fs-6">{t("weekly_earnings")}</p>
          </Col>
          <Col xl="4">
            <Select
              data={data}
              value={filter}
              handleChange={(e) => handleSetFilter(e.target.value)}
              
            />
          </Col>
        </Row>
        <div className="mt-3">
          <ReactApexChart
            options={options}
            series={series}
            type="bar"
            height={maxValue}
          />
        </div>
      </div>
    </div>
  );
};

export default Chart;
